module.exports = __webpack_public_path__ + "static/media/AmericanPancakes.4e13bd0a.jpg";